var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { createContext, useContext, useRef } from 'react';
import { useStateValue } from "../helpers";
import { Modal } from "./Modal";
import { MODAL_VIEW } from "./types";
var notImplementedPresenter = {
    present: function () {
        throw new Error('Method not implemented');
    },
    presentPage: function () {
        throw new Error('Method not implemented');
    },
    presentFullPage: function () {
        throw new Error('Method not implemented');
    },
    dismissLatest: function () {
        throw new Error('Method not implemented');
    },
    dismissAll: function () {
        throw new Error('Method not implemented');
    }
};
export var ModalPresenterContext = createContext({
    modal: notImplementedPresenter
});
function ModalPresenterContainer(_a) {
    var modal = _a.modal, mainContentId = _a.mainContentId;
    var state = useStateValue([]);
    modal.present = function present(renderer, view) {
        var id = Math.random().toString(16);
        var dismiss = function () {
            state.updateValue(function (prevValue) {
                return prevValue.filter(function (i) { return i.id !== id; });
            });
        };
        state.updateValue(function (prevValue) {
            var element = renderer(dismiss);
            if (!element) {
                return prevValue;
            }
            return __spreadArrays(prevValue, [
                {
                    id: id,
                    element: React.createElement(Modal, {
                        isShown: true,
                        render: function () { return element; },
                        mainContentId: mainContentId,
                        view: view
                    })
                }
            ]);
        });
        return dismiss;
    };
    modal.dismissAll = function dismissAll() {
        state.setValue([]);
    };
    modal.dismissLatest = function dismissAll() {
        state.updateValue(function (prevValue) {
            if (!prevValue.length) {
                return prevValue;
            }
            return prevValue.slice(0, prevValue.length - 1);
        });
    };
    modal.presentPage = function presentPage(renderer) {
        return modal.present(renderer, MODAL_VIEW.page);
    };
    modal.presentFullPage = function presentPage(renderer) {
        return modal.present(renderer, MODAL_VIEW.fullPage);
    };
    return React.createElement(React.Fragment, { key: 'modal-manager-container-fragment' }, state.getValue().map(function (item) {
        return React.createElement(React.Fragment, {
            key: item.id
        }, item.element);
    }));
}
export function ModalPresenterProvider(_a) {
    var mainContentId = _a.mainContentId, children = _a.children;
    var ref = useRef({
        modal: notImplementedPresenter
    });
    return React.createElement(ModalPresenterContext.Provider, {
        value: { modal: ref.current.modal }
    }, React.createElement(React.Fragment, { key: 'modal-manager-fragment' }, children, React.createElement(ModalPresenterContainer, {
        modal: ref.current.modal,
        mainContentId: mainContentId
    })));
}
export function useModalPresenter() {
    return useContext(ModalPresenterContext);
}
//# sourceMappingURL=presenter.js.map